// extracted by mini-css-extract-plugin
module.exports = {"btn-manage-recipients":"_1cd2js7vReaNCUPBxpRZMQ"};